<template>
    <div class="dashboard-container">
        <div class="mb-8">
            <h2 class="text-2xl font-bold text-gray-800 mb-4">Dashboard Pengadaan</h2>
            <!-- Add Buat Pengadaan Button for PPK Role -->
            <div v-if="shouldShowCreateButton" class="mt-2">
                <Link 
                    :href="route('dokumen_pengadaan.create_pengadaan')" 
                    class="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transform hover:scale-105 transition-all duration-150"
                >
                    <i class="pi pi-plus-circle text-lg mr-2"></i>
                    Buat Pengadaan Baru
                </Link>
            </div>
        </div>
        
        <div v-if="data.length == 0" class="empty-state">
            <i class="pi pi-inbox text-4xl mb-3 text-gray-400"></i>
            <span class="text-xl text-gray-600">Belum Ada Data Tersedia</span>
        </div>
        <div v-else>
            <div class="procedure-section" v-for="(each_prosedur,idx_prosedur) in data" :key="idx_prosedur">
                <app-menu-bar :title="'Dashboard ' + each_prosedur.nama_prosedur" class="mb-4" />
                <div class="tahap-sections">
                    <div class="tahap-row-wrapper" 
                         v-for="(tahapPair, pairIndex) in getPairedTahap(each_prosedur.data)" 
                         :key="pairIndex">
                        <div v-for="(groupData, tahap) in tahapPair" 
                             :key="tahap" 
                             class="tahap-row">
                            <div class="tahap-label">{{ tahap }}</div>
                            <div class="metro-grid">
                                <div v-for="(item, idx) in groupData" :key="idx" 
                                     class="metro-tile">
                                    <Link :href="item.url" class="tile-content">
                                        <div :class="['tile-inner', getBaseClass(item.class)]">
                                            <div class="tile-label" :title="item.nama_tahap">{{ item.nama_tahap }}</div>
                                            <div class="tile-badge" v-if="item.count">{{ item.count }}</div>
                                            <i :class="getIconClass(item.nama_tahap)" class="tile-icon"></i>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import Menubar from "primevue/menubar";
import AppMenuBar from "../../Components/AppMenuBar.vue";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import DeleteDialog from "../../Components/DeleteDialog";
import Toolbar from "primevue/toolbar";
import { Link } from '@inertiajs/inertia-vue3';

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        Column,
        Button,
        DeleteDialog,
        Toolbar,
        Link,
        InputText,
        AppMenuBar
    },
    props : {
        data : Array,
    },
    data() {
        return {
            tileColors: [
                'bg-blue-600',
                'bg-green-600',
                'bg-purple-600',
                'bg-orange-600',
                'bg-red-600',
                'bg-teal-600',
                'bg-indigo-600',
                'bg-pink-600'
            ]
        };
    },
    created() {
        
    },
    mounted() {
        // Check for success message in session storage
        const showSuccessToast = sessionStorage.getItem('showSuccessToast');
        const successMessage = sessionStorage.getItem('successMessage');
        
        if (showSuccessToast === 'true' && successMessage) {
            // Show success toast
            this.$toast.add({ 
                severity: 'success', 
                summary: 'Berhasil!', 
                detail: successMessage, 
                life: 5000 
            });
            
            // Clear session storage
            sessionStorage.removeItem('showSuccessToast');
            sessionStorage.removeItem('successMessage');
        }
        
        // Check for flash message from Laravel
        if (this.$page.props.flash && this.$page.props.flash.success) {
            this.$toast.add({ 
                severity: 'success', 
                summary: 'Berhasil!', 
                detail: this.$page.props.flash.success, 
                life: 5000 
            });
        }
    },
    computed: {
        shouldShowCreateButton() {

            // console.log(this.$page.props.session_role.role.name);
            // Get the current user's role code from the session
            const userRoleCode = this.$page.props.session_role.role.name;
            // Get the creator role code from the config
            const creatorRoleCode = this.$page.props.appConfig.dokumen_pengadaan_creator_role_code;

            console.log("Creator Role Code: " + creatorRoleCode);
            
            // Show button if user's role code matches the creator role code
            return userRoleCode && creatorRoleCode && userRoleCode.toLowerCase() === creatorRoleCode.toLowerCase();
        }
    },
    methods: {
        groupDataByTahap(data) {
            // Group data by base tahap name (without the status in parentheses)
            return data.reduce((acc, item) => {
                const baseTahap = this.getBaseTahap(item.nama_tahap);
                if (!acc[baseTahap]) {
                    acc[baseTahap] = [];
                }
                acc[baseTahap].push(item);
                return acc;
            }, {});
        },
        getPairedTahap(data) {
            // First group the data by tahap
            const grouped = this.groupDataByTahap(data);
            const tahapEntries = Object.entries(grouped);
            
            // Then pair them into groups of two
            const pairs = [];
            for (let i = 0; i < tahapEntries.length; i += 2) {
                const pair = {};
                pair[tahapEntries[i][0]] = tahapEntries[i][1];
                if (i + 1 < tahapEntries.length) {
                    pair[tahapEntries[i + 1][0]] = tahapEntries[i + 1][1];
                }
                pairs.push(pair);
            }
            return pairs;
        },
        getBaseTahap(tahapName) {
            // Remove the text in parentheses at the end
            return tahapName.replace(/\s*\([^)]*\)\s*$/, '').trim();
        },
        getBaseClass(originalClass) {
            // Map the original class to a metro style color
            const colorIndex = Math.abs(originalClass.split('').reduce((acc, char) => {
                return char.charCodeAt(0) + acc;
            }, 0)) % this.tileColors.length;
            
            return this.tileColors[colorIndex];
        },
        getIconClass(tahap) {
            // Map different stages to appropriate icons
            const tahapLower = tahap.toLowerCase();
            if (tahapLower.includes('draft')) return 'pi pi-file-edit';
            if (tahapLower.includes('review')) return 'pi pi-check-square';
            if (tahapLower.includes('approve')) return 'pi pi-check-circle';
            if (tahapLower.includes('reject')) return 'pi pi-times-circle';
            return 'pi pi-folder';
        }
    }
}
</script>

<style scoped>
.dashboard-container {
    padding: 1.5rem;
    background-color: #f0f0f0;
    min-height: 100vh;
}

.procedure-section {
    margin-bottom: 2rem;
}

.tahap-sections {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.tahap-row-wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
}

.tahap-row {
    background: white;
    border-radius: 8px;
    padding: 1.5rem;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.tahap-label {
    font-size: 1.1rem;
    font-weight: 600;
    color: #374151;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #e5e7eb;
}

.metro-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
}

.metro-tile {
    position: relative;
    width: 100%;
    min-height: 200px;
    height: auto;
}

.tile-content {
    display: block;
    height: 100%;
    text-decoration: none;
}

.tile-inner {
    position: relative;
    min-height: 200px;
    height: 100%;
    padding: 1.5rem;
    color: white;
    transition: all 0.2s ease;
    display: flex;
    flex-direction: column;
    border-radius: 6px;
}

.tile-label {
    font-size: 1.1rem;
    font-weight: 500;
    line-height: 1.4;
    margin-bottom: 1rem;
    word-break: break-word;
}

.tile-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    background: rgba(255, 255, 255, 0.2);
    padding: 0.25rem 0.75rem;
    border-radius: 12px;
    font-size: 0.9rem;
    font-weight: 500;
    min-width: 1.5rem;
    text-align: center;
}

.tile-icon {
    font-size: 2.5rem;
    margin-top: auto;
    opacity: 0.9;
    padding-top: 0.5rem;
}

.tile-inner:hover {
    transform: scale(0.98);
}

@media (max-width: 1024px) {
    .tahap-row-wrapper {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .metro-grid {
        grid-template-columns: 1fr;
        gap: 0.75rem;
    }

    .metro-tile {
        min-height: 180px;
    }

    .tile-inner {
        min-height: 180px;
        padding: 1.25rem;
    }

    .tahap-row {
        padding: 1rem;
    }

    .tile-label {
        font-size: 1rem;
    }

    .tile-icon {
        font-size: 2rem;
    }
}

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4rem 2rem;
    background: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}
</style>
